const toggleSearchClass = (toggle) => {
  const headerSearchElem = document.querySelector('.header-main__middle');
  const searchInput = document.querySelector('#header-search');
  const searchForm = document.querySelector('form.header-search__form');
  document.body.classList.toggle('is-search-open', toggle);

  if (toggle) {
    slideDown(headerSearchElem, 300, 'block');
    searchInput.focus();
  } else {
    slideUp(headerSearchElem, 300);
    searchInput.blur();
    searchForm.reset();
  }
};

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
};

const getHeaderTopBarHeight = () => {
  let headerTopBarHeight = 0;
  const timerModule = document.querySelector('.timer-module');
  const infoBar = document.querySelector('.info-bar');
  if (timerModule || infoBar) {
    if (timerModule && !infoBar) {
      headerTopBarHeight = timerModule.offsetHeight;
    } else if (infoBar) {
      headerTopBarHeight = infoBar.offsetHeight;
    } else {
      headerTopBarHeight = timerModule.offsetHeight + infoBar.offsetHeight;
    }
    document.body.classList.add('has-top-bar');
  }
  document.body.style.setProperty('--top-bar-height', `${headerTopBarHeight}px`);
};

const debounceGetHeaderTopBarHeight = debounce(() => {
  getHeaderTopBarHeight();
}, 100);

const updateWishListQuantityBadge = async () => {
  try {
    const axiosData = {
      action: 'getCurrentLikedNumber',
    };
    const response = await axios.post(localData.siteURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const number = response.data.data;
    const cartQuantityBadge = document.querySelector('.header-main__wishlist-btn  .header-main__badge');

    if (cartQuantityBadge) {
      cartQuantityBadge.innerText = number;
      if (number === 0) {
        cartQuantityBadge.remove();
      }
    } else {
      document.querySelector('.header-main__wishlist-btn').innerHTML += `<div class="header-main__badge">${number}</div>`;
    }
  } catch (error) {
    console.error('Error updating wishlist quantity badge:', error);
  }
};

const initSideCart = () => {
  const addToWishlistButton = cartPopup.querySelectorAll('.cart-popup__product-link');
  addToWishlistButton.forEach((button) => {
    button.addEventListener('click', (e) => {
      const card = button.closest('.cart-popup__product');
      const popup = card.querySelector('.wishlist-popup');
      const productId = card.querySelector('.cart-popup__product-middle').dataset.parentid;
      if (!popup.classList.contains('added')) {
        e.preventDefault();
        const axiosData = new FormData();
        axiosData.append('action', 'toggleItemOnLikedList');
        axiosData.append('productid', productId);
        axios.post(localData.siteURL, axiosData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        // eslint-disable-next-line no-param-reassign
        button.innerHTML = 'Na seznam želja';
        popup.classList.add('added');
        popup.classList.add('is-open');
        setTimeout(() => {
          popup.classList.remove('is-open');
        }, 5000);
        updateWishListQuantityBadge();
      }
    });
  });
};
const toggleCartPopup = () => {
  const cartPopup = document.querySelector('.cart-popup');
  if (cartPopup) {
    const isOpen = cartPopup.classList.contains('is-cart-open');
    cartPopup.classList.toggle('is-cart-open', !isOpen);
    initSideCart();
  }
};

// ------
// Mobile menu toggle
// ------

attachEvent('.mobile-hamburger', 'click', (ev) => {
  ev.preventDefault();
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleSearchClass(false);
  toggleMenuClass(!isOpen);
});

// ------
// Add class to body after some scroll
// ------
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 20);
}

addScrollingClass();

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
  },
  false,
);

// ------
// Open search
// ------
attachEvent('.header-main__search-btn', 'click', (ev) => {
  const isOpen = document.body.classList.contains('is-search-open');
  toggleSearchClass(!isOpen);
  toggleMenuClass(false);
  ev.preventDefault();
});

// ------
// Live header search
// ------
const searchHeaderPosts = (search, index, productPageNum, postPageNum) => {
  const searchResults = document.querySelector('.header-search__results');
  const resultBoxes = document.querySelectorAll('.header-search__results-list');
  const resultBoxFooters = document.querySelectorAll('.header-search__results-footer');
  const loadMoreBtn = document.querySelectorAll('.header-search__results-all-link');
  if (search.value) {
    axios
      .post(
        localData.siteURL,
        {
          action: 'searchPostsHeader',
          keyword: search.value,
          lang: localData.lang,
          index,
          productPageNum: productPageNum || 1,
          postPageNum: postPageNum || 1,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((response) => {
        if (response.data.index === '0') {
          resultBoxes[0].innerHTML = response.data.html_product;
        }
        if (response.data.index === '1') {
          resultBoxes[1].innerHTML = response.data.html_post;
        }
        if (!response.data.index) {
          resultBoxes[0].innerHTML = response.data.html_product;
          resultBoxes[0].style.display = 'grid';
          resultBoxFooters[0].style.display = 'block';
          if (response.data.html_post) {
            resultBoxes[1].style.borderTop = '1px solid';
          }
          if (!response.data.html_product) {
            resultBoxes[0].style.display = 'none';
            resultBoxFooters[0].style.display = 'none';
            resultBoxes[0].innerHTML = response.data.no_results_text;
            resultBoxes[1].style.borderTop = '0px';
          }
          resultBoxes[1].innerHTML = response.data.html_post;
          resultBoxes[1].style.display = 'grid';
          resultBoxFooters[1].style.display = 'block';
          if (!response.data.html_post) {
            resultBoxes[1].style.display = 'none';
            resultBoxFooters[1].style.display = 'none';
          }
          if (!response.data.html_product && !response.data.html_post) {
            resultBoxes[0].style.display = 'grid';
            resultBoxes[1].style.display = 'none';
            resultBoxFooters[1].style.display = 'none';
            resultBoxes[0].innerHTML = response.data.no_results_text;
          }
        }
        if (response.data.more_products === false) {
          loadMoreBtn[0].style.display = 'none';
        } else {
          loadMoreBtn[0].style.display = 'inline-flex';
        }
        if (response.data.more_posts === false) {
          loadMoreBtn[1].style.display = 'none';
        } else {
          loadMoreBtn[1].style.display = 'inline-flex';
        }
        searchResults.style.display = 'block';
      });
  } else {
    searchResults.style.display = 'none';
    resultBoxes[0].innerHTML = '';
    resultBoxes[1].innerHTML = '';
    loadMoreBtn[0].style.display = 'none';
    loadMoreBtn[1].style.display = 'none';
  }
};
const loadMoreSearch = document.querySelectorAll('a.header-search__results-all-link');
const searchField = document.querySelector('input#header-search');
if (searchField) {
  searchField.addEventListener(
    'keyup',
    debounce((e) => {
      if (e.key === 'Escape') {
        toggleSearchClass(false);
      }
      loadMoreSearch.forEach((item, index) => {
        loadMoreSearch[0].dataset.page = 1;
        loadMoreSearch[1].dataset.page = 1;
      });
      searchHeaderPosts(searchField);
    }, 400),
  );
}

loadMoreSearch.forEach((item, index) => {
  let productPageNum = loadMoreSearch[0].dataset.page;
  let postPageNum = loadMoreSearch[1].dataset.page;
  item.addEventListener('click', (e) => {
    e.preventDefault();
    if (index === 0) {
      // eslint-disable-next-line no-plusplus
      loadMoreSearch[0].dataset.page++;
    }
    if (index === 1) {
      // eslint-disable-next-line no-plusplus
      loadMoreSearch[1].dataset.page++;
    }
    productPageNum = loadMoreSearch[0].dataset.page;
    postPageNum = loadMoreSearch[1].dataset.page;
    searchHeaderPosts(searchField, index, productPageNum, postPageNum);
  });
});

// ------
// Get height of timer module
// ------

window.addEventListener('DOMContentLoaded', () => {
  debounceGetHeaderTopBarHeight();

  window.addEventListener('resize', () => {
    debounceGetHeaderTopBarHeight();
  });
});

// ------
// Open Cart
// ------

attachEvent('div.header-main__cart-btn', 'click', (ev) => {
  toggleCartPopup();
  document.body.classList.toggle('noscroll');
});

attachEvent('.cart-popup__close, .cart-popup__overlay', 'click', (ev) => {
  toggleCartPopup();
  document.body.classList.toggle('noscroll');
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.cart-popup').forEach((el) => {
      el.classList.remove('is-cart-open');
      document.body.classList.remove('noscroll');
      toggleSearchClass(false);
    });
  }
});

// ------
// Toggle loader
// ------

const toggleLoader = (show) => {
  const body = document.querySelector('body');
  body.classList.toggle('is-loading', show);
};

const updateCartQuantityBadge = () => {
  let badgeQuantity = 0;
  const cartQuantityBadge = document.querySelector('.header-main__cart-btn  .header-main__badge');
  const purchaseProcessCartEl = document.querySelector('.purchase-process-01__products');
  const popupCartEl = document.querySelector('.cart-popup__product-list');
  if (purchaseProcessCartEl) {
    document.querySelectorAll('.purchase-process-01__product:not(.is-hidden)').forEach((item) => {
      const itemQuantity = item.querySelector('.purchase-process-01__product-amount-price').dataset.quantity;
      badgeQuantity += parseInt(itemQuantity, 10);
    });
  } else if (popupCartEl) {
    document.querySelectorAll('.cart-popup__product:not(.is-hidden)').forEach((item) => {
      const popupItemQuantity = item.querySelector('.cart-popup__product-middle').dataset.quantity;
      badgeQuantity += parseInt(popupItemQuantity, 10);
    });
  }
  if (cartQuantityBadge) {
    cartQuantityBadge.innerText = badgeQuantity;
    if (badgeQuantity === 0) {
      cartQuantityBadge.remove();
    }
  } else {
    document.querySelector('.header-main__cart-btn').innerHTML += `<span class="header-main__badge">${badgeQuantity}</span>`;
  }
};

// ------
// Close search when click out
// ------

document.addEventListener('click', (evt) => {
  const headerSearchBtn = document.querySelector('.header-main__search-btn');
  const headerSearchContainer = document.querySelector('.header-search');

  let targetElement = evt.target; // clicked element

  do {
    if (targetElement === headerSearchContainer || targetElement === headerSearchBtn) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  if (headerSearchContainer) {
    toggleSearchClass(false);
  }
});
